module.exports = __webpack_public_path__ + "media/images/settings-45336371267b0986422d84682b39ecf6.svg";